import { defineComponent, ref } from 'vue';
import axios from "axios";
import { api } from "@/api/api";
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default {
  name: 'welfare_details_brief_m',
  setup() {
    const route = useRoute();
    const get_data = ref({});
    const store = useStore(); // 该方法用于返回store 实例

    // 获取福利详情数据
    let url = api.baseUrl + api.activity + route.params.id;
    axios({
      url,
      method: "get"
    }).then(res => {
      let {
        data
      } = res;
      console.log(data);
      get_data.value = data.data;
    });
    const call = () => {
      store.commit('serviceShow', true);
    };
    return {
      get_data,
      route,
      call
    };
  }
};